import type { IUpdateManagedAccessSettingsRequest } from '@/app-package';
import axios from 'axios';

const updateManagedAccessSettings = async (settings: {
  userId: string;
  singleAccessEnabled: boolean;
}) => {
  const config: IUpdateManagedAccessSettingsRequest = {
    url: `/supra_system/subscription/managed_access_settings`,
    method: 'post',
    data: settings,
  };

  const { data } = await axios.request<{ error?: string }>(config);
  return data;
};

export default updateManagedAccessSettings;
